import React from 'react';
import { Link } from 'react-router-dom';

const Home = () => {
  return (
    <div className="container d-flex flex-column justify-content-center align-items-center" style={{minHeight: '100vh'}}>
      <h1 className="mb-4">Bienvenue sur Vodoun Days</h1>
      <p className="mb-4">Découvrez notre plateforme de gestion</p>
      <Link to="/backoffice" className="btn btn-primary">
        Accéder au Back office
      </Link>
    </div>
  );
};

export default Home; 